function limitVideoInfoWidth() {
    var videoInfoBarWrapper = document.getElementsByClassName('videoInfoBarWrapper')[0];

    if (!!videoInfoBarWrapper.querySelector('.videoPlayer')) {
        var videoInfoBar = videoInfoBarWrapper.getElementsByClassName('videoInfoBar')[0],
            videoPlayerContainer = videoInfoBarWrapper.getElementsByClassName('videoContentContainer')[0],
            leftVideoPos = Math.ceil(videoPlayerContainer.getBoundingClientRect().left),
            infoBarStyle = window.getComputedStyle(videoInfoBar),
            leftInfoBarOffset = Math.ceil(parseFloat(infoBarStyle.marginLeft)) + Math.ceil(parseFloat(infoBarStyle.borderLeftWidth)) + Math.ceil(parseFloat(infoBarStyle.paddingLeft)),
            RIGHT_PADDING_OFFSET = 8,
            MIN_VIEWPORT_SIZE = 970;

        var infoBarMaxWidth = leftVideoPos - leftInfoBarOffset - RIGHT_PADDING_OFFSET;

        var videoInfoChildren = videoInfoBar.children;

        for (var i = 0; i < videoInfoChildren.length; i++) {
            var currentChild = videoInfoChildren[i];
            // below 970 video moves below info bar
            if (window.innerWidth >= MIN_VIEWPORT_SIZE) {
                currentChild.style.maxWidth = infoBarMaxWidth + 'px';
            } else {
                currentChild.style.maxWidth = '';
            }
        }
    }
}

function setStickyVideoPlayerBounds(videoPlayer, videoWidth, videoHeight, headerHeight) {
    var viewportWidth = document.documentElement.clientWidth,
        viewportHeight = document.documentElement.clientHeight,
        headerRightSide = document.querySelector('.header-not-logos-wrapper'),
        newPlayerContainerClientBounds = headerRightSide.getBoundingClientRect(),
        MAX_VIDEO_WIDTH = 420;

    if (isMobileDevice()) {
        viewportHeight = window.innerHeight;
    }

    if (videoWidth > MAX_VIDEO_WIDTH) {
        var videoRatio = videoHeight / videoWidth;

        videoWidth = MAX_VIDEO_WIDTH;
        videoHeight = videoRatio * videoWidth;
    }

    videoPlayer.style.top = Math.ceil(headerHeight) + 'px';
    videoPlayer.style.left = Math.ceil(viewportWidth - (viewportWidth - Math.ceil(newPlayerContainerClientBounds.right) + videoWidth)) + 'px';
    videoPlayer.style.right = Math.ceil(viewportWidth - Math.ceil(newPlayerContainerClientBounds.right)) + 'px';
    videoPlayer.style.bottom = Math.floor(viewportHeight - headerHeight - videoHeight) + 'px';
}

function stickVideoPlayer(videoPlayerWrapper, videoPlayer, headerHeight) {
    if (!videoPlayerWrapper.classList.contains('sticky-init') && !videoPlayerWrapper.classList.contains('is-sticky')) {
        var HEADER_TOP_SPACING = 18,
            videoWidth = Math.ceil(videoPlayer.offsetWidth),
            videoHeight = Math.ceil(videoPlayer.offsetHeight);

        function handleResize() {
            setStickyVideoPlayerBounds(videoPlayerWrapper, videoWidth, videoHeight, headerHeight);
        }

        //Set our initial values
        videoPlayerWrapper.classList.add('is-sticky');
        headerHeight = headerHeight + HEADER_TOP_SPACING;
        setStickyVideoPlayerBounds(videoPlayerWrapper, videoWidth, videoHeight, headerHeight);

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleResize);
        videoPlayerWrapper.addEventListener('remove-resize-handler', function () {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleResize);
        });
    }
}

window.addEventListener('video-player-started', function (event) {
    //We just want to see if even the slightest bit of header is covering our video then we stick to it
    var headerHeight = document.getElementsByTagName('header')[0].offsetHeight,
        videoPlayerContainer = document.getElementsByClassName('videoContentContainer')[0],
        videoPlayerWrapper = videoPlayerContainer.getElementsByClassName('videoPlayerWrapper')[0],
        videoPlayer = videoPlayerWrapper.getElementsByClassName('videoPlayer')[0],
        stickyCloseButton = videoPlayerWrapper.getElementsByClassName('sticky-close')[0],
        specialLinks = Array.from(document.querySelectorAll('.specialLinks a')),
        playerId = event.detail.playerId;

    if (specialLinks.length) {
        headerHeight += specialLinks[0].offsetHeight;
    }

    if (!isElementInView(videoPlayerContainer, headerHeight)) {
        stickVideoPlayer(videoPlayerWrapper, videoPlayer, headerHeight);
        stickyCloseButton.addEventListener('click', handleStickyClose);
    }

    function removeSticky(videoPlayer, stickyCloseButton) {
        videoPlayer.dispatchEvent(new CustomEvent(
            'remove-resize-handler',
            {
                detail: {
                    playerId: playerId
                }
            })
        );

        videoPlayer.style.top = '';
        videoPlayer.style.left = '';
        videoPlayer.style.right = '';
        videoPlayer.style.bottom = '';
        videoPlayer.classList.remove('is-sticky');
        stickyCloseButton.removeEventListener('click', handleStickyClose);
    }

    function handleStickyClose() {
        removeSticky(videoPlayerWrapper, stickyCloseButton);
        window.removeEventListener('scroll', handleWindowScroll);

        if (videoPlayer.classList.contains('wistiaVideoPlayer')) {
            Wistia.api('player' + playerId).pause();
        } else if (floorplanPlayer) {
            floorplanPlayer.pauseVideo();
        } else if (communityPlayer) {
            communityPlayer.pauseVideo();
        }
    }

    function handleWindowScroll() {
        if (isElementInView(videoPlayerContainer, headerHeight)) {
            removeSticky(videoPlayerWrapper, stickyCloseButton);
        } else if (!videoPlayerWrapper.classList.contains('is-sticky')) {
            stickVideoPlayer(videoPlayerWrapper, videoPlayer, headerHeight);
            stickyCloseButton.addEventListener('click', handleStickyClose);
        }
    }

    window.addEventListener('scroll', handleWindowScroll);
});

function setInfoBarOffset(infoBarWrapper, infoBar, arrows, slideNumberText) {
    var infoBarHeight = '-' + infoBar.offsetHeight + 'px',
        infoBarOffset = infoBarWrapper.style.marginTop,
        ARROW_HEIGHT = '35px',
        OFFSET_TO_SLIDE_NUM_TEXT = '48px';

    if (infoBarOffset !== infoBarHeight) {
        infoBarWrapper.style.marginTop = infoBarHeight;
        Array.prototype.forEach.call(arrows, function (arrow) {
            arrow.style.top = 'calc(50% - (' + ARROW_HEIGHT + ' / 2) + (' + infoBarHeight + ' / 2))';
        });
        if (!!slideNumberText) {
            slideNumberText.style.top = 'calc(50% - (' + ARROW_HEIGHT + ' / 2 ) + (' + OFFSET_TO_SLIDE_NUM_TEXT + ') + (' + infoBarHeight + ' / 2))';
        }
    }

    var videoInfoBar = document.querySelector('.videoInfoBar').getBoundingClientRect();
    var videoPlayerWrapper = document.querySelector('.videoPlayerWrapper');
    if (videoPlayerWrapper) {
        var videoPlayerRect = videoPlayerWrapper.getBoundingClientRect();
    }
    if (videoPlayerWrapper && (videoPlayerRect.top < videoInfoBar.top) && (videoPlayerRect.right + 140 > window.innerWidth)) {		// make sure video player does not overlap the expand icon
        $('#heroSlider .heroExpandIconContainer, #heroSlider .fauxExpandIconContainer').css({
            bottom: ($('.videoInfoBar').outerHeight() + 20 + (videoInfoBar.top - videoPlayerRect.top))
        });
    } else {
        $('#heroSlider .heroExpandIconContainer, #heroSlider .fauxExpandIconContainer').css({
            bottom: ($('.videoInfoBar').outerHeight() + 20)
        });
    }
}

function initInfoBar() {
    var infoBarWrapper = document.querySelector('.videoInfoBarWrapper'),
        infoBar = infoBarWrapper.querySelector('.videoInfoBar'),
        heroContent = document.querySelector('.heroContent'),
        arrows = [];

    limitVideoInfoWidth();

    if (!!heroContent) {
        arrows = Array.from(heroContent.querySelectorAll('.sliderArrow'));
        var slideNumberText = document.getElementById('slideNumberText');
        setInfoBarOffset(infoBarWrapper, infoBar, arrows, slideNumberText);
    }

    window.addEventListener('resize', function () {
        limitVideoInfoWidth();

        if (!!heroContent) {
            setInfoBarOffset(infoBarWrapper, infoBar, arrows, slideNumberText);
        }
    });
};

if (document.readyState === 'loading') {  									// Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', initInfoBar);
} else {  																	// `DOMContentLoaded` has already fired
    initInfoBar();
}
